<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-button @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2 d-md-down-none">
      <b-col sm="auto" class="text-center">
        <div class="profile-logo">
          <b-img v-if="!profile.logo.imgBase64" src="/img/icon/No_image.png" />
          <b-img v-else :src="'data:image/jpeg;base64,'+profile.logo.imgBase64" />
        </div>
      </b-col>
      <b-col sm="auto" align-self="center">
        <div class="text-logisty-dark-main search-company-name">
          <b>{{ profile.name }}</b>
        </div>
        <div class="text-muted search-company-address">{{ profile.address }}</div>
      </b-col>
      <b-col align-self="center" class="text-center">
        <div class="text-center float-right">
          <div>โปรไฟล์ถูกดูแล้ว {{ profile.viewCount ? profile.viewCount : 0 }} ครั้ง</div>
          <b-link @click="goRating">
            <div class="" v-if="profile.rating && profile.rating.total > 0">
              <star-rating :enableCursor="true" :disabled="true" :value="profile.rating.avg"></star-rating>
              <div class="text-muted search-company-address">เรตติ้งจากผู้ใช้บริการ {{ profile.rating.total }} คน</div>
            </div>
            <div class="" v-else>
              <star-rating :enableCursor="true" :disabled="true"></star-rating>
              <div class="text-muted search-company-address">ยังไม่มีเรตติ้ง</div>
            </div>
          </b-link>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2 d-lg-none">
      <b-col sm="12" class="text-center">
        <div class="profile-logo">
          <b-img v-if="!profile.logo.imgBase64" src="/img/icon/No_image.png" />
          <b-img v-else :src="'data:image/jpeg;base64,'+profile.logo.imgBase64" />
        </div>
      </b-col>
      <b-col sm="12" align-self="center" class="text-center">
        <div class="text-logisty-dark-main search-company-name">
          <b>{{ profile.name }}</b>
        </div>
        <div class="text-muted search-company-address">{{ profile.address }}</div>
      </b-col>
      <b-col sm="12" align-self="center" class="text-center mt-2">
        <div>โปรไฟล์ถูกดูแล้ว {{ profile.viewCount ? profile.viewCount : 0 }} ครั้ง</div>
        <b-link @click="goRating">
          <div v-if="profile.rating">
            <star-rating :enableCursor="true" :disabled="true" :value="profile.rating.avg"></star-rating>
            <div class="text-muted search-company-address">เรตติ้งจากผู้ใช้บริการ {{ profile.rating.total }} คน</div>
          </div>
          <div v-else>
            <star-rating :enableCursor="true" :disabled="true"></star-rating>
            <div class="text-muted search-company-address">ยังไม่มีเรตติ้ง</div>
          </div>
        </b-link>
      </b-col>
    </b-row>
    <b-row v-if="profile._id != $cookies.get('companyId')" class="mt-4">
      <b-col>
        <b-alert show>รู้จักบริษัทนี้มั้ย? มาช่วยให้คะแนนเพื่อเพิ่มความน่าเชื่อถือของบริษัทนี้กัน <b-link :to="{name: 'สร้างรีวิว', params: {companyUrl:$route.params.companyUrl}}">คลิกที่นี่เพื่อให้คะแนน</b-link></b-alert>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="12" md="12" xl="9">
        <!-- <b-row>
          <b-col>
            <b-card></b-card>
          </b-col>
        </b-row>-->
        <b-row>
          <b-col>
            <b-card class="h-100">
              <b-row>
                <b-col sm="4">
                  <p class="text-muted">ประเภทบริษัท</p>
                  {{ companyType[profile.type] }}
                </b-col>
                <b-col sm="4">
                  <p class="text-muted">ปีที่ก่อตั้ง</p>

                  <span style="font-size: 1.2em;">
                    <b>{{ parseInt($moment(profile.foundingYear).format('YYYY')) + 543 }}</b>
                  </span>
                </b-col>
                <b-col v-if="profile.employeeNum" sm="4">
                  <p class="text-muted">จำนวนพนักงาน</p>

                  <span style="font-size: 1.2em;">
                    <b>
                      <span v-if="profile.employeeNum <= 10">1 - 10 คน</span>
                      <span
                        v-else
                      >{{( (Math.ceil(profile.employeeNum / 10) - 1) * 10 + ' - ' + Math.ceil(profile.employeeNum / 10) * 10)}} คน</span>
                    </b>
                  </span>
                </b-col>
              </b-row>
              <hr class="divider" />
              <b-row class="mt-4">
                <b-col>
                  <h5 class="text-logisty-profile-heading">ใบอนุญาตและมาตรฐาน</h5>
                  <b-row v-if="profile.standard.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col v-for="(item,index) in profile.standard" v-bind:key="index" sm="6">
                          <b-row>
                            <b-col sm="auto" class="pr-0">
                              <img
                                class="logisty-standard-icon"
                                :src="'/img/badge/' + getIcon(item, standardImgs)['img']"
                              />
                            </b-col>
                            <b-col sm="auto" align-self="center">{{ item }}</b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>
                  <h5 class="text-logisty-profile-heading">รางวัล</h5>
                  <b-row v-if="profile.reward.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col v-for="(item,index) in profile.reward" v-bind:key="index" sm="12">
                          <b-row>
                            <b-col sm="auto" class="pr-0">
                              <img class="logisty-standard-icon" src="/img/icon/trophy.png" />
                            </b-col>
                            <b-col sm="auto" align-self="center">{{ item }}</b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>
                  <h5 class="text-logisty-profile-heading">เครือข่าย</h5>
                  <b-row v-if="profile.network.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col v-for="(item,index) in profile.network" v-bind:key="index" sm="6">
                          <b-row>
                            <b-col sm="auto" class="pr-0">
                              <img
                                class="logisty-standard-icon"
                                :src="'/img/badge/' + getIcon(item, networkImgs)['img']"
                              />
                            </b-col>
                            <b-col sm="auto" align-self="center">{{ item }}</b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="$cookies.isKey('token')" sm="12" md="12" xl="3">
        <b-card class="h-100">
          <h5 class="text-logisty-profile-heading">ติดต่อบริษัท</h5>
          <b-row class="mb-1" v-if="profile.contactPersion">
            <b-col sm="auto" class="pr-0">
              <img class="logisty-icon" src="/img/icon/manager.png" />
            </b-col>
            <b-col cols="8" class>{{ profile.contactPersion }}</b-col>
          </b-row>
          <b-row class="mb-1" v-if="profile.tel">
            <b-col sm="auto" class="pr-0">
              <img class="logisty-icon" src="/img/icon/icon_phone.png" />
            </b-col>
            <b-col cols="8" class>{{ profile.tel }}</b-col>
          </b-row>
          <b-row class="mb-1" v-if="profile.email">
            <b-col sm="auto" class="pr-0">
              <img class="logisty-icon" src="/img/icon/icon_mail.png" />
            </b-col>
            <b-col cols="8" class>{{ profile.email }}</b-col>
          </b-row>
          <b-row class="mb-1" v-if="profile.website">
            <b-col sm="auto" class="pr-0">
              <img class="logisty-icon" src="/img/icon/icon_website.png" />
            </b-col>
            <b-col cols="8" class>{{ profile.website }}</b-col>
          </b-row>
          <b-row class="mb-1" v-if="profile.address">
            <b-col sm="auto" class="pr-0">
              <img class="logisty-icon" src="/img/icon/icon_address.png" />
            </b-col>
            <b-col cols="8" class>{{ profile.address }}</b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-else sm="12" md="12" xl="3">
        <b-card class="h-100">
          <h5 class="text-logisty-profile-heading">ติดต่อบริษัท</h5>
          <b-row v-if="profile.contactPersion">
            <b-col>
              <p>กรุณาเข้าสู่ระบบเพื่อดูรายละเอียด</p>
              <b-button variant="primary" @click="login">เข้าสู่ระบบ</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card>
          <h5 class="text-logisty-profile-heading">รูปการบริการ</h5>
          <ImgSlideShow docType="company-showcase" :preventDelete="true" :refId="profile._id" />
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-tabs content-class="mt-3">
            <b-tab title="งานขนส่ง" active>
              <b-row>
                <b-col sm="4">
                  <p class="text-muted">แรงงานลงสินค้า</p>
                  <span style="font-size: 1.2em;">{{ profile.porterService ? 'มี' : 'ไม่มี' }}</span>
                </b-col>
                <b-col sm="4">
                  <p class="text-muted">พื้นที่ให้บริการ</p>
                  <b-row v-if="profile.serviceArea.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col>
                          <ul>
                            <li
                              v-for="(item,index) in profile.serviceArea"
                              v-bind:key="index"
                            >{{ item }}</li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มีบริการ</span>
                </b-col>
                <b-col sm="4">
                  <p class="text-muted">วิ่งข้ามชายแดน</p>
                  <b-row v-if="profile.crossThaiBorder.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col>
                          <ul>
                            <li
                              v-for="(item,index) in profile.crossThaiBorder"
                              v-bind:key="index"
                            >{{ item }}</li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มีบริการ</span>
                </b-col>
              </b-row>
              <hr class="divider" />
              <b-row>
                <b-col>
                  <h5 class="text-logisty-profile-heading">ประเภทรถที่มี</h5>
                  <b-row v-if="profile.ownTruckNumByType.length > 0" class="text-center">
                    <b-col class="mt-2" v-if="fourW.length > 0" sm="12" md="6" xl="4">
                      <b-card class="h-100 mt-2" header="4 ล้อ">
                        <b-row>
                          <b-col v-for="(item,index) in fourW" v-bind:key="index" sm="6">
                            <b-img
                              class="logisty-truck-icon"
                              :src="'/img/truck_icon/' + getIcon(item.name, truckTypeImgs)['img']"
                              fluid
                            ></b-img>
                            <br />
                            {{ item.name }}
                            <br />
                            <b>
                              <span v-if="item.value <= 20">1 - 20 คัน</span>
                              <span
                                v-else
                              >{{( (Math.ceil(item.value / 20) - 1) * 20 + ' - ' + Math.ceil(item.value / 20) * 20)}} คัน</span>
                            </b>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                    <b-col class="mt-2" v-if="sixW.length > 0" sm="12" md="6" xl="4">
                      <b-card class="h-100 mt-2" header="6 ล้อ">
                        <b-row>
                          <b-col v-for="(item,index) in sixW" v-bind:key="index" sm="6">
                            <b-img
                              class="logisty-truck-icon"
                              :src="'/img/truck_icon/' + getIcon(item.name, truckTypeImgs)['img']"
                              fluid
                            ></b-img>
                            <br />
                            {{ item.name }}
                            <br />
                            <b>
                              <span v-if="item.value <= 20">1 - 20 คัน</span>
                              <span
                                v-else
                              >{{( (Math.ceil(item.value / 20) - 1) * 20 + ' - ' + Math.ceil(item.value / 20) * 20)}} คัน</span>
                            </b>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                    <b-col class="mt-2" v-if="tenW.length > 0" sm="12" md="6" xl="4">
                      <b-card class="h-100 mt-2" header="10 ล้อ">
                        <b-row>
                          <b-col v-for="(item,index) in tenW" v-bind:key="index" sm="6">
                            <b-img
                              class="logisty-truck-icon"
                              :src="'/img/truck_icon/' + getIcon(item.name, truckTypeImgs)['img']"
                              fluid
                            ></b-img>
                            <br />
                            {{ item.name }}
                            <br />
                            <b>
                              <span v-if="item.value <= 20">1 - 20 คัน</span>
                              <span
                                v-else
                              >{{( (Math.ceil(item.value / 20) - 1) * 20 + ' - ' + Math.ceil(item.value / 20) * 20)}} คัน</span>
                            </b>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                    <b-col class="mt-2" v-if="puang.length > 0" sm="12" md="6" xl="4">
                      <b-card class="h-100 mt-2" header="รถพ่วง">
                        <b-row>
                          <b-col v-for="(item,index) in puang" v-bind:key="index" sm="6">
                            <b-img
                              class="logisty-truck-icon"
                              :src="'/img/truck_icon/' + getIcon(item.name, truckTypeImgs)['img']"
                              fluid
                            ></b-img>
                            <br />
                            {{ item.name }}
                            <br />
                            <b>
                              <span v-if="item.value <= 20">1 - 20 คัน</span>
                              <span
                                v-else
                              >{{( (Math.ceil(item.value / 20) - 1) * 20 + ' - ' + Math.ceil(item.value / 20) * 20)}} คัน</span>
                            </b>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                    <b-col class="mt-2" v-if="trailer.length > 0" sm="12" md="6" xl="4">
                      <b-card class="h-100 mt-2" header="เทรลเลอร์">
                        <b-row>
                          <b-col v-for="(item,index) in trailer" v-bind:key="index" sm="6">
                            <b-img
                              class="logisty-truck-icon"
                              :src="'/img/truck_icon/' + getIcon(item.name, truckTypeImgs)['img']"
                              fluid
                            ></b-img>
                            <br />
                            {{ item.name }}
                            <br />
                            <b v-if="item.name === 'หัวลาก'">
                              <span v-if="item.value <= 20">1 - 20 คัน</span>
                              <span
                                v-else
                              >{{( (Math.ceil(item.value / 20) - 1) * 20 + ' - ' + Math.ceil(item.value / 20) * 20)}} คัน</span>
                            </b>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
              <hr class="divider" />
              <b-row>
                <b-col>
                  <h5 class="text-logisty-profile-heading">งานที่เคยรับ</h5>
                  <!-- <b-row>
                    <b-col
                      v-for="(item,index) in profile.natureOfCargo"
                      v-bind:key="index"
                      sm="4"
                      xs="12"
                    >
                      <img class="logisty-icon" src="/img/icon/bullet.png" />
                      {{ item }}
                    </b-col>
                  </b-row>-->
                  <b-row v-if="profile.natureOfCargo.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col>
                          <ul>
                            <li
                              v-for="(item,index) in profile.natureOfCargo"
                              v-bind:key="index"
                            >{{ item }}</li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
              <hr v-if="myProfile" class="divider" />
              <b-row v-if="myProfile">
                <b-col>
                  <h5 class="text-logisty-profile-heading">งานเที่ยวกลับที่ต้องการ</h5>
                  <b-row v-if="profile.backhaulRequest.length > 0">
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      v-for="(item,index) in profile.backhaulRequest"
                      v-bind:key="index"
                    >
                      <b-card bg-variant="logisty-main">
                        <b-row>
                          <b-col sm="5">
                            <b-card>
                              <span class="text-muted">จาก</span>
                              <br />
                              <b>{{ item.from }}</b>
                            </b-card>
                          </b-col>
                          <b-col sm="2" class="text-center" align-self="center">
                            <img class="logisty-icon" src="/img/icon/icon_FromTo.png" />
                          </b-col>
                          <b-col sm="5">
                            <b-card>
                              <span class="text-muted">ไป</span>
                              <br />
                              <b>{{ item.to }}</b>
                            </b-card>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <span class="text-muted">ประเภทรถ</span>
                            <b-row class="text-center mt-2">
                              <b-col
                                v-for="(truck,truckIndex) in item.truckType"
                                v-bind:key="truckIndex"
                                sm="4"
                              >
                                <b-img
                                  class="logisty-truck-icon"
                                  :src="'/img/truck_icon/' + getIcon(truck, truckTypeImgs)['img']"
                                  fluid
                                ></b-img>
                                <br />
                                {{ truck }}
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มี</span>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="งานขนส่งสินค้าระหว่างประเทศ"
              v-if="profile.typeOfTransport.length > 0 || profile.serviceCountry.length > 0"
            >
              <b-row>
                <b-col>
                  <p class="text-muted">รูปแบบการขนส่ง</p>
                  <b-row v-if="profile.typeOfTransport.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col>
                          <ul>
                            <li
                              v-for="(item,index) in profile.typeOfTransport"
                              v-bind:key="index"
                            >{{ item }}</li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มีบริการ</span>
                </b-col>
              </b-row>
              <hr class="divider" />
              <b-row v-if="profile.serviceCountry.length > 0">
                <b-col>
                  <h5 class="text-logisty-profile-heading">ประเทศที่ให้บริการ</h5>
                  <b-row class="text-center">
                    <b-col
                      v-for="(item,index) in profile.serviceCountry"
                      v-bind:key="index"
                      sm="auto"
                    >
                      <img class="logisty-icon" src="/img/icon/globe.png" />
                      <br />
                      {{ item }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="คลังสินค้า"
              v-if="profile.warehouseSpace || profile.warehouseType.length > 0"
            >
              <b-row>
                <b-col sm="4">
                  <p class="text-muted">พื้นที่</p>
                  <span
                    style="font-size: 1.2em;"
                  >{{ profile.warehouseSpace ? profile.warehouseSpace + ' ตร.ม.' : 'ไม่มีบริการ' }}</span>
                </b-col>
                <b-col sm="4">
                  <p class="text-muted">ประเภทคลังสินค้า</p>
                  <b-row v-if="profile.warehouseType.length > 0">
                    <b-col sm="12">
                      <b-row>
                        <b-col>
                          <ul>
                            <li
                              v-for="(item,index) in profile.warehouseType"
                              v-bind:key="index"
                            >{{ item }}</li>
                          </ul>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <span style="font-size: 1.2em;" v-else>ไม่มีบริการ</span>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div ref="ratingele">
          <RatingList  :revieweeId="profile._id"/>
        </div>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import Profile from '../services/http/Profile'
import ImgSlideShow from '../components/ImgSlideShow'
import ModalLoading from '../components/ModalLoading'
import RatingList from './Rating/List'
import StarRating from '../components/StarRating'

export default {
  components: {
    ModalLoading,
    ImgSlideShow,
    RatingList,
    StarRating
  },
  data () {
    return {
      profile: null,
      companyType: {
        'company': 'บริษัท',
        'individual': 'บุคคลธรรมดา',
        'company-limited': 'บริษัทจำกัด',
        'public-company-limited': 'บริษัท มหาชน จำกัด',
        'limited-partnership': 'ห้างหุ้นส่วนจำกัด'
      },
      truckTypeImgs: [
        // { value: '10 ล้อคอกตํ่า', img: 'icon_10W_ShortKok' },
        // { value: '10 ล้อคอกตํ่าดัมพ์', img: 'icon_10W_ShortKok' },
        // { value: '10 ล้อคอกสูง', img: 'icon_10W_Kok' },
        // { value: '10 ล้อคอกสูงดัมพ์', img: 'icon_10W_Kok_Dump' },
        // { value: '10 ล้อตู้ทึบ', img: 'icon_10W_Box' },
        // { value: '10 ล้อพื้นเรียบ', img: 'icon_10W_FlatSmooth' },
        // { value: '10 ล้อเครน', img: 'icon_10W_Crane' },
        // { value: '10 ล้อแทงเกอร์', img: 'icon_10W_Petro' },
        // { value: '10 ล้อกระบะคาร์โก้', img: 'icon_10W_Kraba' },
        // { value: '10 ล้อ ตู้เย็น', img: 'icon_10W_Fridge' },
        // { value: '4 ล้อ คอกสูง', img: 'icon_4W_Kok' },
        // { value: '4 ล้อ ตู้ทึบ', img: 'icon_4W_Box' },
        // { value: '4 ล้อ จัมโบ้ คอก', img: 'icon_4W_jumbo_Kok' },
        // { value: '4 ล้อ จัมโบ้ ตู้ทึบ', img: 'icon_4W_jumbo_Box' },
        // { value: '4 ล้อ ตู้เย็น', img: 'icon_4W_Fridge' },
        // { value: '4 ล้อ จัมโบ้ ตู้เย็น', img: 'icon_4w_jumbo_Fridge' },
        // { value: '6 ล้อคอกสูง 5.5 เมตร', img: 'icon_6W_Kok' },
        // { value: '6 ล้อคอกสูง 6.5 เมตร', img: 'icon_6W_Kok' },
        // { value: '6 ล้อคอกสูง 7 เมตร', img: 'icon_6W_Kok' },
        // { value: '6 ล้อตู้ทึบ 5.5 เมตร', img: 'icon_6W_Box' },
        // { value: '6 ล้อตู้ทึบ 6.5 เมตร', img: 'icon_6W_Box' },
        // { value: '6 ล้อตู้ทึบ 7 เมตร', img: 'icon_6W_Box' },
        // { value: '6 ล้อพื้นเรียบ', img: 'icon_6W_FlatSmooth' },
        // { value: '6 ล้อเครน', img: 'icon_6W_Crane' },
        // { value: '6 ล้อ ตู้เย็น', img: 'icon_6W_Fridge' },
        // { value: '6 ล้อกระบะคาร์โก้', img: 'icon_6W_Kraba' },
        // { value: 'พ่วงคอกตํ่า', img: 'icon_Puang_ShortKok' },
        // { value: 'พ่วงคอกตํ่าดัมพ์', img: 'icon_Puang_ShortKok' },
        // { value: 'พ่วงคอกสูง', img: 'icon_Puang_Kok' },
        // { value: 'พ่วงคอกสูงดัมพ์', img: 'icon_Puang_Kok' },
        // { value: 'พ่วงตู้ทึบ', img: 'icon_Puang_Box' },
        // { value: 'พ่วงพื้นเรียบ', img: 'icon_Puang_FlatSmooth' },
        // { value: 'หางคอก', img: 'icon_tail_Kok' },
        // { value: 'หางคอกดั๊มพ์', img: 'icon_tail_Kok' },
        // { value: 'หางตู้คอนเทนเนอร์ 20ft', img: 'icon_tail_Fishbone' },
        // { value: 'หางตู้คอนเทนเนอร์ 40ft', img: 'icon_tail_Fishbone' },
        // { value: 'หางพื้นเรียบ', img: 'icon_tail_FlatSmooth' },
        // { value: 'หางพื้นเรียบ low bed', img: 'icon_tail_Low-bed' },
        // { value: 'หางม่านข้าง', img: 'icon_tail_CurtainBox' },
        // { value: 'หางก้าง', img: 'icon_tail_Fishbone' },
        // { value: 'หางแทงเกอร์', img: 'icon_tail_Petro' },
        // { value: 'หัวลาก', img: 'icon_trailerHead' },
        // { value: 'default', img: 'truck_normal' },
        // { value: 'เทรลเลอร์หางก้าง', img: 'icon_Fishbone' },
        // { value: 'เทรลเลอร์หางพื้นเรียบ', img: 'icon_FlatSmooth' },
        // { value: 'เทรลเลอร์หางพื้นเรียบชานต่ำ (Low Bed)', img: 'icon_Low-bed' },
        // { value: 'เทรลเลอร์หางม่านข้าง', img: 'icon_CurtainBox' },
        // { value: 'เทรลเลอร์หางคอก', img: 'icon_Kok' },
        // { value: 'เทรลเลอร์หางคอกดั๊มพ์', img: 'icon_Kok' },
        // { value: 'เทรลเลอร์หางตู้เย็น 40ft', img: 'icon_40Fridge' },
        // { value: 'เทรลเลอร์หางตู้เย็น 20ft', img: 'icon_20Fridge' },
        // { value: 'เทรลเลอร์หางแทงเกอร์', img: 'icon_Petro' },
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 40ft', img: 'icon_40Box' },
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 20ft', img: 'icon_20Box' }
      ],
      standardImgs: [
        { value: 'หนังสือทะเบียนผู้ประกอบการขนส่งไม่ประจำทาง', img: '26.png' },
        { value: 'ตัวแทนออกของรับอนุญาต', img: '27.png' },
        { value: 'Q-Mark', img: '28.jpg' },
        { value: 'ISO 9001:2015', img: '29.png' },
        { value: 'AEO', img: '30.png' },
        { value: 'OHSAS 18001:2007', img: '36.png' },
        { value: 'default', img: 'diamond.png' }
      ],
      networkImgs: [
        { value: 'LTAT สมาคมขนส่งทางบกแห่งประเทศไทย นครสวรรค์', img: '5.jpg' },
        { value: 'IM-EX TA สมาคมขนส่งสินค้าเพื่อการนำเข้าและส่งออก', img: '6.jpg' },
        { value: 'TTLA สมาคมขนส่งสินค้าและโลจิสติกส์ไทย', img: '7.png' },
        { value: 'WTA สมาคมรถบรรทุกภาคตะวันตก', img: '8.jpg' },
        { value: 'TTA สมาคมขนส่งสินค้าจังหวัดตาก', img: '9.jpg' },
        { value: 'NTA สมาคมขนส่งสินค้าภาคอีสาน', img: '10.gif' },
        { value: 'ASLT สมาคมโลจิสติกส์และขนส่งภาคใต้', img: '11.jpg' },
        { value: 'LCTA สมาคมผู้ประกอบการขนส่งแหลมฉบังชลบุรี', img: '12.jpg' },
        { value: 'ASEANLP สมาคมการค้าโลจิสติกส์และผู้ค้าอาเซียน', img: '13.png' },
        { value: 'TIFFA สมาคมผู้รับจัดการขนส่งสินค้าระหว่างประเทศ', img: '14.jpg' },
        { value: 'TACBA สมาคมตัวแทนออกของรับอนุญาตไทย', img: '15.jpg' },
        { value: 'TLAPS สมาคมไทยโลจิสติกส์และการผลิต', img: '16.png' },
        { value: 'CTAT สมาคมชิปปิ้งแห่งประเทศไทย', img: '17.png' },
        { value: 'TEXCA สมาคมขนส่งสินค้าเร่งด่วนไทย', img: '18.jpg' },
        { value: 'TAFA สมาคมตัวแทนขนส่งสินค้าทางอากาศไทย', img: '19.png' },
        { value: 'ETA สมาคมขนส่งสินค้าภาคตะวันออก', img: '20.jpg' },
        { value: 'IATA สมาคมขนส่งทางอากาศระหว่างประเทศ', img: 'connection.png' },
        { value: 'FIATA International Federation of Freight Forwarders Associations', img: 'connection.png' },
        { value: 'สภาหอการค้าแห่งประเทศไทย', img: '21.jpg' },
        { value: 'WCA Inter Global', img: '32.jpg' },
        { value: 'สมาคมผู้ประกอบการรถเครน', img: '35.png' },
        { value: 'สภาผู้ส่งสินค้าทางเรือแห่งประเทศไทย', img: '37.jpg' },
        { value: 'สมาคมภัตตาคารไทย', img: '38.png' },
        { value: 'ชมรมขนส่งสินค้าท่าเรือแหลมฉบังชลบุรี', img: '39.jpg' },
        { value: 'Overseas Project Cargo Association', img: '40.jpg' },
        { value: 'สมาพันธ์เอสเอ็มอีไทย', img: '41.png' },
        { value: 'Global Ocean Air Logistics', img: '42.png' },
        { value: 'default', img: 'connection.png' }
      ],
      tenW: [],
      sixW: [],
      fourW: [],
      puang: [],
      trailer: [],
      myProfile: false
    }
  },
  mounted () {
    this.init()
    // console.log(this.getIcon('หัวลาก', this.truckTypeProfileOptions))
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')

      this.$store.dispatch('loadTruckType').then((result) => {
        let truckTypeOptions = this.$store.state.truckType
        this.truckTypeImgs = truckTypeOptions.map((x) => {
          return {
            value: x.typeName,
            img: x.icon
          }
        })
        this.truckTypeImgs.push({ value: 'default', img: 'truck_normal.png' })
        // console.log(this.truckTypeImgs)
      })

      var profile = new Profile()
      try {
        var result = null

        if (this.$cookies.isKey('token')) {
          result = await profile.getPrivateProfile(this.$route.params.companyUrl)
        } else {
          result = await profile.getPublicProfile(this.$route.params.companyUrl)
        }

        if (result.code === 1) {
          this.profile = result.data
          // check is my profile
          if (this.profile._id === this.$cookies.get('companyId')) {
            this.myProfile = true
          }
          if (this.profile.saveDraft && this.profile._id !== this.$cookies.get('companyId')) {
            this.$router.push({
              name: 'บริษัท'
            })
          }
          profile.updateCompanyInfoViewCount({ companyId: this.profile._id })
          // prepare truckType Own
          if (this.profile.ownTruckNumByType.length > 0) {
            this.tenW = this.profile.ownTruckNumByType.filter(x => x.name.includes('10 ล้อ'))
            this.sixW = this.profile.ownTruckNumByType.filter(x => x.name.includes('6 ล้อ'))
            this.fourW = this.profile.ownTruckNumByType.filter(x => x.name.includes('4 ล้อ'))
            this.puang = this.profile.ownTruckNumByType.filter(x => x.name.includes('พ่วง'))
            this.trailer = this.profile.ownTruckNumByType.filter(x => x.name.includes('หาง') || x.name.includes('หัวลาก'))
            var indexHead = this.trailer.findIndex(x => x.name === 'หัวลาก')
            if (this.trailer.length > 0) {
              this.trailer.unshift(this.trailer.splice(indexHead, 1)[0])
            }
            if (this.natureOfCargo.length > 0) {
              this.natureOfCargo.sort()
            }
          }
        } else {
          this.$router.push({
            name: 'บริษัท'
          })
        }
      } catch (error) {
        console.log(error)
      }
      Window.Event.$emit('closeModalLoading')
    },
    goBack () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'บริษัท'
        })
      }
    },
    login () {
      this.$router.push({ name: 'เข้าสู่ระบบ' })
    },
    getIcon (key, data) {
      var ret = data.find(x => x.value === key)
      if (ret) {
        return ret
      } else {
        return data.find(x => x.value === 'default')
      }
    },
    goRating () {
      let element = this.$refs['ratingele']
      element.scrollIntoView()
    }
  }
}
</script>
